import { render } from "./serviceheader.vue?vue&type=template&id=03dd5ba6&scoped=true"
const script = {}

import "./serviceheader.vue?vue&type=style&index=0&id=03dd5ba6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dd5ba6"]])

export default __exports__